













































import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import Dygraph from 'dygraphs';
import moment from 'moment';
// import RGBColorParser from '@/components/staff/rgbcolor.js';

import RGBColor from 'rgbcolor';

@Component({
    components: {},
})
export default class VueDygraph extends Vue {
    // get sensor_name() {
    //     return this.$store.getters.FirstInfo.sensor_name;
    // }

    // get bcpid() {
    //     return this.$store.getters.BcpIds[0];
    // }

    public $refs!: {
        graphElement: HTMLElement;
    };

    @Prop({ type: String, default: 'Values' }) public title!: string;
    @Prop({ type: String, default: 'Time' }) public xlabel!: string;
    @Prop({ type: String, default: 'Values' }) public ylabel!: string;

    private defaultPlotter = Dygraph.Plotters.linePlotter;

    private plotter = Dygraph.Plotters.linePlotter;

    private waiting: boolean = false;
    private showBarChart = false;
    private graphOptions = {};
    private graph: any;
    private graphData = [[0, 0]];

    // [
    //                 //     [ new Date("2009/07/12"), 100, 200 ],
    //                 //     [ new Date("2009/07/19"), 150, 220 ]
    //                 // ],
    //                 // {
    //                 //     labels: [ "x", "A", "B" ]
    //                 // });

    public updateOptions(options: object) {
        // console.debug(this.graphData[0].length)
        // Merge data and options
        const obj = Object.assign({}, this.graphOptions, options);
        this.graph.updateOptions(obj);
    }

    // public updateGraph() {
    //   // console.debug(this.graphData[0].length);
    //   // Merge data and options
    //   const obj = Object.assign({}, this.graphOptions, {file: this.graphData});
    //   this.$data._graph.updateOptions(obj);
    // }

    // @Watch('graphData')
    // protected onGraphDataChanged(newDate: any, oldDate: any): any {

    // }

    public setWaiting(waiting: boolean) {
        this.waiting = waiting;
    }

    public setData(labels: string[], data: any) {
        this.graphData = data;
        this.graph.updateOptions({ labels: labels, file: this.graphData });
    }

    public resetZoom() {
        this.graph.resetZoom();
    }

    public clear() {
        this.graph.updateOptions({ labels: ['', ''], file: [[0, 0]] });
    }

    private barChartPlotter = (e: any) => {
        // We need to handle all the series simultaneously.
        if (e.seriesIndex !== 0) {
            return;
        }

        const g = e.dygraph;
        const ctx = e.drawingContext;
        const sets = e.allSeriesPoints;
        const y_bottom = e.dygraph.toDomYCoord(0);

        // Find the minimum separation between x-values.
        // This determines the bar width.
        let min_sep = Infinity;
        for (let j = 0; j < sets.length; j++) {
            const points = sets[j];
            for (let i = 1; i < points.length; i++) {
                const sep = points[i].canvasx - points[i - 1].canvasx;
                if (sep < min_sep) {
                    min_sep = sep;
                }
            }
        }
        const bar_width = Math.ceil((2.0 / 3) * min_sep);

        const fillColors = [];
        const strokeColors = g.getColors();

        for (let i = 0; i < strokeColors.length; i++) {
            const color = new RGBColor(strokeColors[i]);
            color.r = Math.floor((255 + color.r) / 2);
            color.g = Math.floor((255 + color.g) / 2);
            color.b = Math.floor((255 + color.b) / 2);
            fillColors.push(color.toRGB());
        }

        const alternate = [];

        // preallocate alternative array of -1 and 1 for speed when drawing below
        for (let i = 0; i < 50; i++) {
            alternate.push(Math.pow(-1, i));
        }

        for (let j = 0; j < sets.length; j++) {
            ctx.fillStyle = fillColors[j];
            ctx.strokeStyle = strokeColors[j];
            for (let i = 0; i < sets[j].length; i++) {
                const p = sets[j][i];
                const center_x = p.canvasx;

                let plot_offset = 0;
                const real_bar_width = bar_width / sets.length;

                const k = Math.floor(j / 2.0);
                plot_offset = (alternate[j] * (2 * (k + 1) - 1)) / 2.0;

                const x_left = center_x - plot_offset * real_bar_width;

                ctx.fillRect(
                    x_left,
                    p.canvasy,
                    real_bar_width,
                    y_bottom - p.canvasy,
                );

                ctx.strokeRect(
                    x_left,
                    p.canvasy,
                    real_bar_width,
                    y_bottom - p.canvasy,
                );
            }
        }
    }

    // 'graphOptions': {
    //   handler (val, oldVal) {
    //     console.debug('graphOptions update, was waiting : ', this.waitingForUpdate)
    //     if (this.waitingForUpdate) {
    //       this.updateGraph()
    //       this.waitingForUpdate = false
    //     } else {
    //       this.$data._graph.updateOptions(val)
    //     }
    //   },

    // public getOption(name: string, opt_seriesName: string):  ;

    // }

    private toggleBarChart() {
        this.showBarChart = !this.showBarChart;

        if (this.showBarChart) {
            this.plotter = this.barChartPlotter;
        } else {
            this.plotter = this.defaultPlotter;
        }

        this.updateOptions({ plotter: this.plotter });
    }

    private zoomCallback(minDate: number, maxDate: number, yRanges: []) {
        const self = this;

        if (this.graph == null) {
            return;
        }

        if (this.graph.isZoomed('x') === false) {
            // This is true when the user has double clicked the graph to cancel zoom

            self.$emit('resetZoom');
            return;
        }

        const detailStartDateTm = moment.unix(Math.trunc(minDate) / 1000); // new Date(minDate);
        const detailEndDateTm = moment.unix(Math.trunc(maxDate) / 1000); // new Date(maxDate);

        self.$emit('zoom', detailStartDateTm, detailEndDateTm);
    }

    private created() {
        this.plotter = this.defaultPlotter;
    }

    private mounted() {
        const self = this;

        const div = document.getElementById('graphdiv');

        this.graphOptions = {
            zoomCallback: this.zoomCallback,
            title: '',
            // linear_regression_large_gaps: json.linear_regression_large_gaps,
            // linear_regression_real_sensor_points: json.linear_regression_real_sensor_points,
            xlabel: self.xlabel,
            ylabel: self.ylabel,
            // labelsDivWidth: 350,
            digitsAfterDecimal: 4,
            maxNumberWidth: 10,
            includeZero: true,
            drawPoints: true,
            strokeWidth: 4,
            labelsShowZeroValues: true,
            showRoller: false,
            connectSeparatedPoints: true,
            // drawCallback: function(graph) {
            //   $('#graph_loading').hide();
            // },
            axes: {
                x: null,
            },
            plotter: self.plotter,
            // highlightSeriesOpts: json.graph_options['highlightSeriesOpts'],
        };

        this.graph = new Dygraph(div, this.graphData, this.graphOptions);

        // this.graphOptions.clickCallback = this.clickCallback;
        // this.graphOptions.drawCallback = this.drawCallback;
        // this.graphOptions.highlightCallback = this.highlightCallback;
        // this.graphOptions.pointClickCallback = this.pointClickCallback;
        // this.graphOptions.underlayCallback = this.underlayCallback;
        // this.graphOptions.unhighlightCallback = this.unhighlightCallback;
        // this.graphOptions.zoomCallback = this.zoomCallback;
        // this.graphOptions.drawHighlightPointCallback = this.drawHighlightPointCallback;
        // this.graphOptions.drawPointCallback = this.drawPointCallback;
        // this.graphOptions.interactionModel = this.interactionModel;
    }
}
